import {css} from 'lit';
export const styles = css`:host {
  --dial-size: 180px;
  --legend-min-width: 180px;
  --legend-max-width: 380px;
  --track-color: var(--gray-100, #f3f3f3);
  --value-color: var(--gray-900, #212529);
}

/* Legend beside the dial where there is room, under it where there is not.
   Wrapping needs no measurement, so the component works in any container. */
.chart {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  margin-top: 8px;
}

.dial {
  position: relative;
  flex: 0 0 auto;
  width: var(--dial-size);
  max-width: 100%;
}

svg {
  display: block;
  width: 100%;
  height: auto;
}

.track {
  fill: var(--track-color);
}

.slice {
  transition: opacity 0.2s ease;
}

.slice:hover {
  opacity: 0.85;
}

/* The dial keeps its aspect ratio, so the middle can be placed as a fraction of
   it and stay centred at any size. */
.middle {
  position: absolute;
  top: 25%;
  right: 25%;
  bottom: 25%;
  left: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  text-align: center;
  pointer-events: none;
}

.figure {
  color: var(--value-color);
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 1.1;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.figure-label {
  color: var(--heading-color);
  font-size: 0.6875rem;
  line-height: 1.2;
}

/* Capped: stretched across a wide card the values drift so far from their
   labels that the rows stop reading as rows. */
.legend {
  flex: 1 1 var(--legend-min-width);
  min-width: 0;
  max-width: var(--legend-max-width);
  margin: 0;
  padding: 0;
  list-style: none;
}

.legend li {
  display: grid;
  grid-template-columns: 10px 1fr auto auto;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  font-size: 0.8125rem;
}

.legend li + li {
  border-top: 1px solid var(--border-color);
}

.swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.name {
  color: var(--label-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.amount {
  color: var(--value-color);
  font-weight: 600;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.percent {
  min-width: 3.5em;
  color: var(--heading-color);
  text-align: right;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
`;
export default styles;
